<template>
  <div class="container-fluid" style="padding:0;overflow-x:hidden">
    <div class="row g-0">
          <div class="col-md-4" style="height:320px">
            <SwapSetup :swapid="swapid" />
          </div>
          <div class="col-md-8" style="height:320px">
            <TextArea ref="TEXTAREA01" globid="TEXTAREA01" :swapid="swapid"/>
          </div>
    </div>
    <div class="row g-0">
          <div class="col-md-4" style="height:320px">
            <SwapExec :swapid="swapid"/>
          </div>
          <div class="col-md-8" style="height:290px">
            <IframeArea ref="IFRAME01" globid="IFRAME01" :swapid="swapid"/>
          </div>
    </div>
  </div>
</template>

<script>
import TextArea from './TextArea.vue'
import IframeArea from './IframeArea.vue'
import SwapExec from './SwapExec.vue' 
import SwapSetup from './SwapSetup.vue' 

export default {
  name: 'SwapOperation',
  components: {
      TextArea, IframeArea, SwapExec, SwapSetup
  },
  data() {
      return {
         filepath : ''
      }
  },
  methods: {
    writearea (data) {
      this.$refs.TEXTAREA01.mydata = data  ;
    },
    writeiframe (data) {
        this.$refs.IFRAME01.writearea( "<pre>" + data + "</pre>") ;
    }
  },
  props: {
    swapid : String 
  },
}
// vim:expandtab:smartindent:tabstop=2:softtabstop=2:shiftwidth=2:
</script>
